import AbstractVariableStrategy from "./AbstractVariableStrategy";

export default class RankingVariableStrategy extends AbstractVariableStrategy {
    buildVariables(queryBuilder, context) {
        queryBuilder.addFilterField('first', 'Int');
        queryBuilder.addFilterField('period', 'String!');
        queryBuilder.addFilterField('vendors', '[String]!');
        queryBuilder.addFilterField('ranking', 'Int!');

        super.buildVariables(queryBuilder, context);
    }
}
